// src/components/EditableCell.js
import React from 'react';
import {Box, IconButton, TextField, CircularProgress} from '@mui/material';
import {Edit, Check, Close} from '@mui/icons-material';

export default function EditableCell({
                                         value,
                                         isEditing,
                                         onEditStart,
                                         onEditChange,
                                         onConfirm,
                                         onCancel,
                                         isLoading,
                                     }) {
    if (isLoading) {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width="100%"
                minHeight="28px"   // gives a bit of vertical space so it looks centered
            >
                <CircularProgress size={16}/>
            </Box>
        );
    }

    if (isEditing) {
        return (
            <Box
                display="flex"
                alignItems="center"
                width="100%"
                gap={0.5}
                sx={{ minWidth: '200px' }}
                // Block any clicks/dbl-clicks from reaching the <td>
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
                onDoubleClick={(e) => e.stopPropagation()}
            >
                <TextField
                    value={value}
                    onChange={onEditChange}
                    variant="outlined"
                    size="small"
                    autoFocus
                    multiline
                    maxRows={4}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            onConfirm();
                        } else if (e.key === 'Escape') {
                            onCancel();
                        }
                    }}
                    sx={{
                        flexGrow: 1,
                        flexShrink: 1,
                        minWidth: 0,
                        '& .MuiOutlinedInput-root': {
                            paddingRight: '0 !important',
                        },
                        '& .MuiInputBase-input': {
                            padding: '10px 12px',
                            fontSize: '0.875rem',
                            minHeight: '20px',
                        },
                    }}
                    // extra safety (not strictly required because the Box stops it)
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => e.stopPropagation()}
                />
                <Box display="flex" flexDirection="column" gap={0.25} flexShrink={0}>
                    <IconButton
                        size="small"
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => {
                            e.stopPropagation();
                            onConfirm();
                        }}
                    ><Check fontSize="small"/></IconButton>
                    <IconButton
                        size="small"
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => {
                            e.stopPropagation();
                            onCancel();
                        }}
                    ><Close fontSize="small"/></IconButton>
                </Box>
            </Box>
        );
    }

    // View mode: double-click anywhere in the cell to enter edit
    return (
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ width: '100%' }}>
          <span style={{
              opacity: value ? 1 : 0.6,
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'anywhere',
              width: '100%'
          }}>
        {value || <em style={{fontStyle: 'normal'}}>—</em>}
             </span>
        </Box>
    );
}
